import type { DataDetailResponse } from '@/types/data'

interface DataDetailCacheState {
  dataId: number | null
  detail: DataDetailResponse | null
}

// 데이터 상세 페이지 진입 시 라우터 가드(권한 체크)가 이미 받아온 GET /api/data/:data_no
// 응답을 페이지 컴포넌트가 재사용하기 위한 단일 항목 캐시.
// 상세 페이지는 한 번에 하나만 보므로 여러 건을 담는 Map 은 필요 없다.
export const useDataDetailCacheStore = defineStore('dataDetailCache', {
  // 네비게이션 1회에만 쓰이는 임시 캐시라 로컬 저장소에 영속화할 필요가 없음
  // (앱 전역에 auto persist 플러그인이 걸려 있어 명시적으로 꺼준다)
  persist: false,
  state: (): DataDetailCacheState => ({
    dataId: null,
    detail: null,
  }),
  actions: {
    set(dataId: number, detail: DataDetailResponse) {
      this.dataId = dataId
      this.detail = detail
    },
    // dataId 가 일치할 때만 캐시를 꺼내주고, 꺼낸 뒤에는 즉시 비운다(1회성 소비).
    consume(dataId: number): DataDetailResponse | null {
      if (this.dataId === dataId && this.detail) {
        const detail = this.detail
        this.clear()
        return detail
      }
      return null
    },
    clear() {
      this.dataId = null
      this.detail = null
    },
  },
})
